import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-774a14a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col justify-center mb-4 mt-6" }
const _hoisted_2 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_3 = { class: "text-3xl font-bold text-center mb-2" }
const _hoisted_4 = { class: "text-2xl font-bold text-center mb-2" }
const _hoisted_5 = { class: "receipt-modal" }
const _hoisted_6 = { class: "text-xl font-bold text-center mb-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 bottom-border" }, null, -1))
const _hoisted_8 = { class: "text-lg text-center text-gray-500 text-sm mb-3" }
const _hoisted_9 = { class: "product-list overflow-y-auto max-h-72" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "text-lg font-bold" }
const _hoisted_12 = { class: "flex flex-col items-end" }
const _hoisted_13 = { class: "flex items-center gap-2 font-bold tracking-wide" }
const _hoisted_14 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_15 = {
  key: 1,
  class: "text-lg"
}
const _hoisted_16 = { class: "flex flex-row items-center gap-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg text-center" }, "+", -1))
const _hoisted_18 = { class: "font-bold text-lg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg text-center" }, "-", -1))
const _hoisted_20 = { class: "flex justify-end gap-2" }
const _hoisted_21 = { class: "text-lg" }
const _hoisted_22 = { class: "text-lg" }

import { currency } from "@/_helpers";

import { ref } from "vue";
import { cartService } from "@/_services";

import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
} from "vue";

const __default__ = defineComponent({
  name: "LbrxOfferSelectionModal",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    data: {},
    posConfig: {},
    currencyCode: {}
  },
  emits: ["update:open", "confirmOffer", "cancelOffer", "updateCart"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  }
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

const closeModal = () => {
  isOpen.value = false;
};

const formatAmount = (
  amount: any,
  currencyCode: any,
  decimalPrecision: any
) => {
  const safeAmount = isNaN(amount) || amount == null ? 0 : amount;
  const safeCurrencyCode = currencyCode ?? "";
  const safeDecimalPrecision = decimalPrecision ?? 0;
  return currency.formatAmount(
    safeAmount,
    safeCurrencyCode,
    safeDecimalPrecision
  );
};

//data
const selectedItems = ref<any[]>([]);

function isSelected(item: any) {
  return item.discount_quantity > 0;
}

// Watch for changes in discount_quantity and update selectedItems accordingly
watch(() => props.data, (newData) => {
  if (newData) {
    selectedItems.value = newData.filter((item: any) => item.discount_quantity > 0);
  }
}, { deep: true, immediate: true });

const setLoyaltyCart = async () => {
  try {
    let formData = new FormData();
    const cartInfoStr = localStorage.getItem("cart_info");
    const cartId = cartInfoStr ? JSON.parse(cartInfoStr).id || "" : "";
    formData.append("cart_id", cartId);
    const selectedItemsIds = selectedItems.value
      .map((item) => item.id)
      .join(",");
    const discountQuantity = selectedItems.value.map((item) => item.discount_quantity).join(",");
    formData.append("loyalty_items_ids", selectedItemsIds);
    formData.append("discount_quantities", discountQuantity);
    const response = await cartService.setLoyaltyCart(formData);

    //console.log("response set loyalty cart", response);
    emit("updateCart");
  } catch (error) {
    console.log("error set loyalty cart", error);
  }
};

const confirm = async () => {
  if (selectedItems.value.length > 0) {
    await setLoyaltyCart();
    closeModal();
    // emit("confirmOffer", selectedItems.value);
  }
};

const cancel = () => {
  emit("cancelOffer");
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    centered: "",
    width: "700px",
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    closable: false,
    class: "offer-modal"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_a_button, {
          size: "large",
          style: _normalizeStyle({
            color: 'white',
            backgroundColor: _ctx.posConfig?.store?.primaryColor || '#fc8019',
            borderColor: _ctx.posConfig?.store?.primaryColor || '#fc8019',
          }),
          disabled: selectedItems.value.length === 0,
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("Pos.Confirm")), 1)
          ]),
          _: 1
        }, 8, ["style", "disabled"]),
        _createVNode(_component_a_button, {
          key: "back",
          size: "large",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("Pos.Cancel")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Pos.Congratulation")), 1)
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Pos.CsEarnedFreeItem")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Pos.AvailableProducts") || "PRODUITS DISPONIBLES"), 1),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Pos.SelectProductToOffer") || "Sélectionnez un produit à offrir"), 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass([
            'product-row flex items-center justify-between rounded-lg mb-2 px-3 py-2 cursor-pointer transition',
            isSelected(item)
              ? 'border-2'
              : 'bg-white border border-transparent hover:bg-gray-50',
          ]),
              style: _normalizeStyle(
            isSelected(item)
              ? {
                  backgroundColor:
                    (_ctx.posConfig?.store?.primaryColor || '#fc8019') + '20',
                  borderColor: _ctx.posConfig?.store?.primaryColor || '#fc8019',
                }
              : {}
          )
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.quantity - item.discount_quantity) + " x " + _toDisplayString(item.product.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (item.discount_quantity  && item.discount_quantity == 0 )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(formatAmount(
                  item.total,
                  _ctx.currencyCode,
                  _ctx.posConfig.posConfig.decimalPrecision
                )), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(formatAmount(
                  item.discount_quantity * item.product.full_price,
                  _ctx.currencyCode,
                  _ctx.posConfig.posConfig.decimalPrecision
                )), 1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_button, {
                      class: "qt-btn",
                      disabled: item.discount_quantity >= item.quantity,
                      onClick: ($event: any) => (item.discount_quantity++)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(item.discount_quantity), 1),
                    _createVNode(_component_a_button, {
                      class: "qt-btn",
                      disabled: item.discount_quantity <= 0,
                      onClick: ($event: any) => (item.discount_quantity--)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ])
                ])
              ])
            ], 6))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})